import {AgeType, Class, ConditionType, FeatCategory, GlossaryType, Size} from '../generated/types';
import {uppercaseFirstLetter} from './utils';

export const Abilities: {[key: string]: string} = {
	Strength: 'Сила',
	Dexterity: 'Ловкость',
	Constitution: 'Выносливость',
	Wisdom: 'Мудрость',
	Intelligence: 'Интеллект',
	Charisma: 'Харизма',
};

const SourceBooks: {[key: string]: string} = {
	DMG: 'Руководство мастера подземелий 2014',
	MM: 'Энциклопедия чудовищ 2014',
	PHB: 'Книга игрока 2014',
	XGE: 'Руководство Занатара по всему',
	SCAG: 'Побережье мечей: руководство искателя приключений',
	LMoP: 'Затерянные копи Фандельвера',
	BGDIA: 'Врата Балдура. Нисхождение в Авернус',
	WDH: 'Вотердип. Драконий куш',
	HotDQ: 'Сокровища Королевы Драконов',
	ToD: 'Тирания драконов',
	PotA: 'Князья Апокалипсиса',
	XPHB: 'Книга игрока',
	XDMG: 'Руководство мастера подземелий',
	XMM: 'Энциклопедия чудовищ',
	AU: 'Раскрытая магия',
	FRHoF: 'Забытые Королевства: герои Фейруна',
	FRAiF: 'Забытые Королевства: приключения в Фейруне',
	PaBTSO: 'Фандельвер и его глубины: Расколотый обелиск',
	DDBD: 'D&D Beyond Drops',
};

export const SpellSchools: {[key: string]: string} = {
	Abjuration: 'Преграждение',
	Conjuration: 'Воплощение',
	Divination: 'Прорицание',
	Enchantment: 'Очарование',
	Evocation: 'Эвокация',
	Illusion: 'Иллюзия',
	Necromancy: 'Некромантия',
	Transmutation: 'Превращение',
};

export const DamageTypes: Record<string, string> = {
	necrotic: 'Некротический',
	acid: 'Кислота',
	fire: 'Огонь',
	cold: 'Холод',
	bludgeoning: 'Дробящий',
	slashing: 'Режущий',
	radiant: 'Лучистый',
	lightning: 'Молния',
	poison: 'Яд',
	piercing: 'Колющий',
	psychic: 'Психический',
	thunder: 'Гром',
	force: 'Сила',
};

const ItemTypes: Record<string, string> = {
	Weapon: 'Оружие',
	Armor: 'Броня',
	Treasure: 'Сокровище',
	Ship: 'Судно',
	Vehicle: 'Транспорт',
	TradeBar: 'Слиток',
	TradeGood: 'Товары',
	ArtisansTools: 'Инструменты ремесленника',
	Explosive: 'Взрывчатка',
	FoodAndDrink: 'Пища и питьё',
	AdventuringGear: 'Снаряжение искателя приключений',
	GamingSet: 'Настольная игра',
	Tool: 'Инструмент',
	TackAndHarness: 'Упряжь и уход',
	Rod: 'Скипетр',
	Wand: 'Жезл',
	Ring: 'Кольцо',
	Mount: 'Скакун',
	Potion: 'Зелье',
	Poison: 'Яд',
	Scroll: 'Свиток',
	SpellcastingFocus: 'Фокусирующий предмет',
	Staff: 'Посох',
};

const AttackTypes: {[key: string]: string} = {
	Melee: 'Ближнего боя',
	Ranged: 'Дистанционная',
};

const Areas: {[key: string]: string} = {
	Cube: 'Куб',
	Line: 'Линия',
	Sphere: 'Сфера',
	Cylinder: 'Цилиндр',
	Cone: 'Конус',
	Square: 'Сфера',
};

const ItemTiers: Record<string, string> = {
	M: 'Значимый',
	m: 'Незначимый',
};

const ItemRarities: Record<string, string> = {
	Uncommon: 'необычный',
	Rare: 'редкий',
	VeryRare: 'крайне редкий',
	None: 'нет редкости',
	Unknown: 'неизвестной редкости',
	Legendary: 'легендарный',
	Artifact: 'артефакт',
	Common: 'обычный',
	UnknownMagic: 'неизвестной редкости (магический)',
	Varies: 'различной редкости',
};

const PoisonTypes: Record<string, string> = {
	Ingested: 'поглощаемый',
	Inhaled: 'вдыхаемый',
	Contact: 'контактный',
	Injury: 'оружейный',
};

export const WeaponCategories: Record<string, string> = {
	Martial: 'Военное',
	Simple: 'Простое',
};

export const ArmorType: Record<string, string> = {
	Light: 'Лёгкая',
	Heavy: 'Тяжёлая',
	Medium: 'Средняя',
	Shields: 'Щиты',
};

const WeaponProperties: Record<string, string> = {
	A: 'Боеприпасы',
	AF: 'Боеприпасы огнестрельные',
	H: 'Автоматическое',
	TH: 'Фехтовальное',
	V: 'Тяжёлое',
	F: 'Лёгкое',
	L: 'Заряжаемое',
	T: 'Длинное',
	LD: 'Перезарядка',
	R: 'Особое',
	RLD: 'Метательное',
	S: 'Полуторное',
	BF: 'Двуручное',
};

export const Skills: Record<string, string> = {
	Acrobatics: 'Акробатика',
	AnimalHandling: 'Дрессировка',
	Arcana: 'Магия',
	Athletics: 'Атлетика',
	Deception: 'Обман',
	History: 'История',
	Insight: 'Проницательность',
	Intimidation: 'Запугивание',
	Investigation: 'Расследование',
	Medicine: 'Медицина',
	Nature: 'Природа',
	Perception: 'Внимание',
	Performance: 'Исполнение',
	Persuasion: 'Убеждение',
	Religion: 'Религия',
	SleightOfHand: 'Ловкость рук',
	Stealth: 'Скрытность',
	Survival: 'Выживание',
};

const AgeTypes: Record<string, string> = {
	[AgeType.Renaissance]: 'старинное',
	[AgeType.Modern]: 'современное',
	[AgeType.Futuristic]: 'футуристическое',
};

export const Conditions: Record<string, string> = {
	[ConditionType.Charmed]: 'Обворожение',
	[ConditionType.Frightened]: 'Испуг',
	[ConditionType.Grappled]: 'Захват',
	[ConditionType.Incapacitated]: 'Выведенное из строя',
	[ConditionType.Blinded]: 'Слепота',
	[ConditionType.Deafened]: 'Глухота',
	[ConditionType.Prone]: 'Распластанность',
	[ConditionType.Restrained]: 'Обездвиживание',
	[ConditionType.Petrified]: 'Окаменение',
	[ConditionType.Invisible]: 'Невидимость',
	[ConditionType.Paralyzed]: 'Паралич',
	[ConditionType.Poisoned]: 'Отравление',
	[ConditionType.Stunned]: 'Шок',
	[ConditionType.Unconscious]: 'Без сознания',
	[ConditionType.Exhaustion]: 'Утомление',
};

export enum SpeedType {
	Walk = 'walk',
	Burrow = 'burrow',
	Fly = 'fly',
	Swim = 'swim',
	Climb = 'climb',
}

export const SpeedTypes: Record<string, string> = {
	walk: 'ходьба',
	burrow: 'рытьё',
	fly: 'полёт',
	swim: 'плаванье',
	climb: 'лазанье',
};

export enum MonsterType {
	aberration = 'aberration',
	celestial = 'celestial',
	construct = 'construct',
	dragon = 'dragon',
	elemental = 'elemental',
	fey = 'fey',
	fiend = 'fiend',
	giant = 'giant',
	humanoid = 'humanoid',
	monstrosity = 'monstrosity',
	ooze = 'ooze',
	plant = 'plant',
	undead = 'undead',
	beast = 'beast',
}

export const CreatureTypes: Record<string, string> = {
	aberration: 'аберрация',
	celestial: 'небожитель',
	construct: 'конструкция',
	dragon: 'дракон',
	elemental: 'элементаль',
	fey: 'фея',
	fiend: 'бестия',
	giant: 'великан',
	humanoid: 'гуманоид',
	monstrosity: 'монстр',
	ooze: 'жижа',
	plant: 'растение',
	undead: 'нежить',
	beast: 'животное',
};

export const Sizes: Record<string, string> = {
	[Size.Gargantuan]: 'Исполинский',
	[Size.Huge]: 'Огромный',
	[Size.Large]: 'Крупный',
	[Size.Medium]: 'Средний',
	[Size.Small]: 'Небольшой',
	[Size.Tiny]: 'Маленький',
};

export enum Alignment {
	N = 'N',
	E = 'E',
	L = 'L',
	C = 'C',
	G = 'G',
	U = 'U',
}

export const Alignments: Record<string, string> = {
	N: 'Нейтральный',
	E: 'Злой',
	L: 'Принципиальный',
	C: 'Хаотичный',
	G: 'Добрый',
	U: 'без мировоззрения',
};

export enum Sense {
	darkvision = 'darkvision',
	truesight = 'truesight',
	blindsight = 'blindsight',
}

export const Senses: Record<string, string> = {
	darkvision: 'Ночное зрение',
	blindsight: 'Слепозрение',
	truesight: 'Истинное зрение',
};

export const Environments: Record<string, string> = {
	any: 'любая',
	mountain: 'Горы',
	planar: 'Планы',
	underdark: 'Подземье',
	underwater: 'Подводный мир',
	arctic: 'Приполярье',
	swamp: 'Болото',
	coastal: 'Побережье',
	desert: 'Пустыня',
	hill: 'Холмы',
	forest: 'Лес',
	grassland: 'Степь',
	urban: 'Город',
};

export const Planars: Record<string, string> = {
	air: 'Стихийный план Воздуха',
	beastlands: 'Звериные Земли',
	lower: 'Нижние',
	upper: 'Верхние',
	fire: 'Стихийный план Огня',
	abyss: 'Бездна',
	'nine hells': 'Девять Преисподних',
	shadowfell: 'Царство Теней',
	feywild: 'Страна Фей',
	limbo: 'Лимб',
};

export const Treasures: Record<string, string> = {
	implements: 'Инвентарь',
	individual: 'Личные',
	relics: 'Реликвии',
	any: 'любые',
	arcana: 'Магия',
	armaments: 'Вооружение',
};

export const GlossaryTypes: Record<GlossaryType, string> = {
	[GlossaryType.Action]: 'Действие',
	[GlossaryType.Attitude]: 'Отношение',
	[GlossaryType.AreaOfEffect]: 'Область действия',
	[GlossaryType.Condition]: 'Состояние',
	[GlossaryType.Hazard]: 'Опасность',
};

export const FeatCategories: Record<FeatCategory, string> = {
	[FeatCategory.FightingStyle]: 'Черта Боевого стиля',
	[FeatCategory.General]: 'Универсальная черта',
	[FeatCategory.EpicBones]: 'Черта Эпического дара',
	[FeatCategory.Origin]: 'Черта Происхождения',
	[FeatCategory.PlanarPact]: 'Планарный договор',
};

export const itemTierToString = (value: string | null) => (value ? ItemTiers[value] : 'Нет');
export const ageTypeToString = (value: string | null) => (value ? AgeTypes[value] : 'Нет');
export const weaponCategoryToString = (value: string | null) => (value ? WeaponCategories[value] : 'Нет');

export const weaponPropertyToString = (value: string | null) => (value ? WeaponProperties[value] : 'Нет');
export const poisonTypeToString = (value: string | null) => (value ? PoisonTypes[value] : 'Нет');
export const itemRarityToString = (value: string | null) => (value ? ItemRarities[value] : 'Нет');

export const abilityToString = (value: string | null) => (value ? Abilities[value] : 'Нет');
export const sourceBookToString = (value: string | null) => (value ? SourceBooks[value] || value : 'Нет');

export const spellSchoolToString = (value: string | null) => (value ? SpellSchools[value] : 'Нет');
export const damageTypesToString = (value: string | null) => (value ? DamageTypes[value] : 'Без урона');
export const classToString = (value: Class | null) => (value ? value.title : 'Нет');
export const attackTypesToString = (value: string | null) => (value ? AttackTypes[value] : 'Нет');
export const areasToString = (value: string | null) => (value ? Areas[value] : 'Нет');
export const itemTypesToString = (value: string | null) => (value ? ItemTypes[value] : 'Нет');

export const conditionsToString = (value: string | null) => (value ? Conditions[uppercaseFirstLetter(value)] : 'Нет');
export const speedsToString = (value: string | null) => (value ? SpeedTypes[value] : 'Нет');
export const monsterTypesToString = (value: string | null) => (value ? CreatureTypes[value] : 'Нет');
export const sizesToString = (value: string | null) => (value ? Sizes[value] : 'Нет');
export const alignmentsToString = (value: string | null) => (value ? Alignments[value] : 'Нет');
export const skillsToString = (value: string | null) => (value ? Skills[value] : 'Нет');
export const sensesToString = (value: string | null) => (value ? Senses[value] : 'Нет');
export const treasuresToString = (value: string | null) => (value ? Treasures[value] : 'Нет');
export const environmentsToString = (value: string | null) => (value ? Environments[value] : 'Нет');
export const planarsToString = (value: string | null) => (value ? Planars[value] : 'Нет');
export const glossaryTypeToString = (value: GlossaryType | null) => (value ? GlossaryTypes[value] : 'Нет');
export const featCategoryToString = (value: FeatCategory | null) => (value ? FeatCategories[value] : 'Нет');
